import Vue from 'vue';
import { ToastOptions } from 'vue-toasted';
import { LocalStorageKeys } from './app.constants';

export default class Utils {
  public static readonly defaultToastConfig: ToastOptions = {
    theme: 'bubble',
    position: 'bottom-center',
    duration: 5000,
    singleton: true,
    action: {
      text: 'X',
      onClick: (e, toast) => {
        toast.goAway(0);
      },
    },
  };

  public static toQueryString = (obj: any) => {
    return Object.keys(obj)
      .map(key => {
        return key + '=' + obj[key];
      })
      .join('&');
  };

  public static fromQueryString = (queryString: string): object => {
    const params: any = {};
    let queries;
    let temp;
    let i;
    let l;
    queries = queryString.split('&');

    for (i = 0, l = queries.length; i < l; i++) {
      temp = queries[i].split('=');
      params[temp[0]] = temp[1];
    }
    return params;
  };

  public static toastShow = (message: string, config?: object) => {
    Vue.toasted.show(message || '', config || Utils.defaultToastConfig);
  };

  public static toastSuccess = (message: string, config?: object) => {
    Vue.toasted.success(message || '', config || Utils.defaultToastConfig);
  };

  public static toastError = (message: string, config?: object) => {
    Vue.toasted.error(message || '', config || Utils.defaultToastConfig);
  };
  public static jsonParse<T>(jsonString: string): T | null {
    try {
      const object = JSON.parse(jsonString);
      return object as T;
    } catch (e) {
      return null;
    }
  }

  public static hasEmptyKey(obj: any) {
    if (!obj || Object.keys(obj).length === 0) {
      return true;
    }
    const hasUndefinedKey =
      Object.keys(obj).filter((key: string) => {
        return typeof obj[key] === 'undefined' || obj.key === '';
      }).length > 0;
    return hasUndefinedKey;
  }

  public static trySetLanguage = (): void => {
    const haveSetLanguage =
      localStorage.getItem(LocalStorageKeys.HAVE_SET_LANGUAGE) || '';
    const canSetLanguage = haveSetLanguage.toLowerCase().trim() !== 'true';

    if (canSetLanguage) {
      localStorage.setItem(LocalStorageKeys.HAVE_SET_LANGUAGE, 'true');

      let browserLanguage = navigator.language || '';
      browserLanguage = browserLanguage.toLowerCase().trim();

      if (browserLanguage.includes('es')) {
        document.cookie = 'googtrans=/en/es';
      } else if (browserLanguage.includes('zh')) {
        document.cookie = 'googtrans=/en/zh-CN';
      } else if (browserLanguage.includes('fr')) {
        document.cookie = 'googtrans=/en/fr';
      }
    }
  };

  public static formatPhoneNumber(phone: string): string {
    if (!phone) {
      return '';
    }
    const normalized = phone.replace(/[^\d]/g, '');

    if (normalized.length === 10) {
      return phone.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
    }

    return normalized;
  }
}

export const loadExternalScript = (
  scriptUrl: string,
  async: boolean = true
) => {
  return new Promise((resolve, reject) => {
    const existingEl: HTMLScriptElement | null = document.querySelector(
      `[src='${scriptUrl}']`
    );
    if (existingEl) {
      if (existingEl.classList.contains('loading')) {
        const lastOnload = existingEl.onload;
        existingEl.onload = function(e) {
          if (lastOnload) {
            lastOnload.bind(this)(e);
          }
          resolve();
        };
      } else {
        resolve();
      }
      return;
    }

    const el = document.createElement('script');
    el.setAttribute('async', async ? 'async' : 'false');
    el.setAttribute('type', 'text/javascript');
    el.setAttribute('src', scriptUrl);
    el.classList.add('loading');
    el.onerror = reject;
    el.addEventListener('load', e => {
      el.classList.remove('loading');
      resolve();
    });
    if (document.head) {
      document.head.append(el);
    }
  });
};
